import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import CardQna from "../Card/CardQna";

function QnaHome(props) {
  const {
    maindata,
    setQna,
    qna,
    setTitleAudio,
    setAudioId,
    setOpenLogin,
    token,
    eventCode,
    setPremiumDialog,
    eventData,
    expired,
  } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div style={{ padding: 0, margin: "32px 0" }} className="qna last-event">
        <div className="head-section">
          <h1>{t("question-answer")}</h1>
          <button
            onClick={() => {
              if (eventData && new Date(eventData.endDate) < new Date()) {
                return setPremiumDialog(true);
              }
              if (expired) {
                return setPremiumDialog(true);
              }
              if (token && token !== null) {
                props.history.push(`/e/${eventCode}/qna`);
                return;
              }
              setOpenLogin(true);
            }}
            className="look-all"
          >
            {t("see-all")}
          </button>
        </div>
        {qna?.slice(0, 5).map((item, index) => (
          <CardQna
            eventCode={eventCode}
            data={item}
            key={index}
            audioId={item?.audioId ?? null}
            setTitleAudio={setTitleAudio}
            setAudioId={(id) => {
              setAudioId(null);
              setTimeout(() => {
                setAudioId(id);
              }, 100);
            }}
            setOpenLogin={setOpenLogin}
          />
        ))}
      </div>
    </React.Fragment>
  );
}

export default withRouter(QnaHome);
